import React from 'react'
import {browserHistory} from 'react-router'
import styled from 'styled-components'
import SearchImage from '../../static/search.svg'
import SearchWhiteImage from '../../static/searchWhite.svg'
import SearchBlueImage from '../../static/searchBlue.svg'
import InputText from '../../basic/InputText'
import {withState} from 'recompose'
import TranslateText from 'src/text/modal';

const Container = styled.div`
  position: relative;
  width: 50%;
  display: flex;
  align-items: center;
  z-index: 10;  
`

const SearchButton = styled.div`
  position: absolute;
  top: 20px;
  right: 10px;
  display: inline-block;
  background: url(${SearchWhiteImage}) no-repeat;
  width: 30px;
  height: 30px;
  z-index: 3;
  
  &.active {
    background: url(${SearchImage}) no-repeat;
    
    &:hover {
      background: url(${SearchBlueImage}) no-repeat;
      cursor: pointer;
    }
  }  
`

const Code = ({ value, onFocus, onChange, active, style, focus, setFocus, translateLabelPlace = 'bottom' }) => (
  <Container style={style}>
    <TranslateText
      id="search__code"
      style={{ height: '100%' }}
      place={translateLabelPlace}
      render={text => {
        return (
          <InputText
            style={{
              fontSize: '16px',
            }}
            placeholder={text}
            value={value}
            onFocus={(e) => {
              setFocus(true)
              onFocus(e)
            }}
            onBlur={() => {
              setFocus(false)
            }}
            onChange={onChange}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && value) {
                browserHistory.push('/article/' + value)
              }
            }}
          />
        );
      }}
    />
    <SearchButton
      className={`search-btn ${focus ? 'active' : ''}`}
      onClick={() => {
        browserHistory.push('/article/' + value)
      }}
    />
  </Container>
)

export default withState('focus', 'setFocus', false)(Code)


// WEBPACK FOOTER //
// ./src/finwhale/search/code.js